// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDetailsSummaryStyles } from "@sc/App/Components/ProductDetails/ProductDetailsSummary";
import { color, ellipsis } from "@sc/XDL/Utilities";
import { css } from "styled-components";

productDetailsSummaryStyles.container = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        @media print {
            display: none;
        }
    `,
};
productDetailsSummaryStyles.leftSection = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

productDetailsSummaryStyles.productInfo = {
    css: css`
        display: flex;
        align-items: center;
        gap: 22px;
    `,
};

productDetailsSummaryStyles.separator = {
    css: css`
        height: 56px;
        width: 1px;
        border-left: 1px solid ${color("common.border")};
        margin: 0 16px;
    `,
};
productDetailsSummaryStyles.rightSection = {
    css: css`
        display: flex;
        flex-direction: column;
        max-width: 293px;
        width: 293px;
        gap: 8px;
        align-items: flex-end;
        & > div {
            width: auto;
        }
    `,
};
productDetailsSummaryStyles.productImageWrapper = {
    css: css`
        display: flex;
    `,
};
productDetailsSummaryStyles.productImage = {
    css: css`
        height: 91px;
        width: 91px;
        img {
            height: auto;
            max-height: 100%;
            width: 100%;
            object-fit: contain;
        }
    `,
};
productDetailsSummaryStyles.logoImage = {
    css: css`
        &,
        svg {
            height: 56px;
            width: 50px;
        }
    `,
};
productDetailsSummaryStyles.descriptionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        max-width: 573px;
    `,
};
productDetailsSummaryStyles.productTitle = {
    size: 14,
    weight: "bold",
    css: css`
        letter-spacing: 0;
        line-height: 16px;
        ${ellipsis(2)}
    `,
};

productDetailsSummaryStyles.productPrice = {
    wrapper: {
        css: css`
            width: auto;
        `,
    },
    price: {
        priceText: {
            css: css`
                margin-bottom: 0;
                font-size: 20px;
                line-height: 28px;
                font-weight: bold;
            `,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                css: css`
                    white-space: nowrap;
                    font-size: 14px;
                    line-height: 22px;
                `,
            },
        },
    },
};

productDetailsSummaryStyles.productActionsExtendedStyles = {
    addToCartContainer: {
        css: css`
            &&&& {
                width: 100%;
            }
        `,
    },
};

productDetailsSummaryStyles.productBrand = {
    nameLink: {
        typographyProps: {
            css: css`
                &&&& {
                    color: ${color("text.link")};
                    font-weight: bold;
                }
            `,
        },
    },
    nameText: {
        css: css`
            &&&& {
                font-weight: bold;
            }
        `,
    },
};

productDetailsSummaryStyles.productAvailabilityStyles = {
    availabilityByWarehouseLinkGridItem: {
        css: css`
            display: none;
        `,
    },
};
